export default {
    filter: 'Filter',
    sort: 'Sortiraj',
    detail_search: 'Pretražite detaljno',
    detail: 'Detaljno',
    price_missmatch: 'Cena od mora da bude manja od cene do',
    fields: {
        term: {
            label: 'Termin za pretragu',
            placeholder: 'Unesite termin za pretragu ovde',
        },
        include_description: {
            label: 'Pretraži i tekst oglasa',
        },
        city: {
            label: 'Grad',
            placeholder: 'Izaberi',
        },
        currency: {
            label: 'Valuta',
        },
        category: {
            label: 'Kategorija',
            placeholder: 'Odaberite',
        },
        subcategory: {
            label: 'Potkategorija',
            placeholder: 'Odaberite',
        },
        price_from: {
            label: 'Cena od',
            placeholder: 'Unesi',
        },
        price_to: {
            label: 'Cena do',
            placeholder: 'Unesi',
        },
    },
    sort_options: {
        sort: 'Sortiraj',
        createdAt_ASC: 'Datumu rastuće',
        createdAt_DESC: 'Datumu opadajuće',
        distance_ASC: 'Udaljenost',
        priceRSD_ASC: 'Ceni rastuće',
        priceRSD_DESC: 'Ceni opadajuće',
        averageRating_ASC: 'Oceni rastuće',
        averageRating_DESC: 'Oceni opadajuće',
    },
}
